/**
 * OLD CART DRAWER - MIGRATED FROM REZ-OLD
 * Main cart drawer functionality with bundle support and upsells
 * Dependencies: jQuery (CDN), Slick Carousel (CDN)
 */

// Selectors variables to replace
let cart_icon = '#cart-icon-bubble';
let cart_count = '#cart-icon-bubble .cart-count-bubble';

/**
 * GiftManager - Handles automatic gift add/remove based on cart threshold
 * Tracks tier 2 gift threshold and manages gift items in cart
 */
class GiftManager {
  constructor() {
    this.isProcessing = false;
    this.debounceTimer = null;
    this.giftPropertyKey = '_is_gift';
  }

  getConfig() {
    const progressBar = document.querySelector('shipping-progress-bar');
    if (!progressBar) return null;
    
    const enableTier2 = progressBar.getAttribute('enable-tier2') === 'true';
    const tier2Threshold = parseInt(progressBar.getAttribute('tier2-threshold')) || 0;
    const giftVariantId = progressBar.getAttribute('tier2-gift-variant-id');
    
    return {
      enabled: enableTier2,
      threshold: tier2Threshold,
      giftVariantId: giftVariantId || null
    };
  }

  isCrossSellItem(item) {
    const properties = item.properties || {};
    return properties._upsell === true || String(properties._upsell) === 'true';
  }

  async postCart(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      throw new Error('Cart request failed');
    }
    return response.json();
  }

  async syncProgressGifts(cart = null) {
    if (this.isProcessing) {
      this.pendingProgressSync = true;
      return;
    }

    const root = document.querySelector('[data-hover-progress]');
    if (!root || isCartVariantHidden(root.closest('.cart-progress--new') || root)) return;

    this.isProcessing = true;

    try {
      if (!cart) cart = await this.fetchCart();

      const steps = Array.from(root.querySelectorAll('[data-progress-step]')).map((step) => ({
        type: step.dataset.type,
        threshold: parseInt(step.dataset.threshold, 10) || 0,
        variantId: step.dataset.variantId ? parseInt(step.dataset.variantId, 10) : null
      }));
      const rate = parseFloat(window.Shopify?.currency?.rate || '1') || 1;
      const giftItems = cart.items.filter((item) => this.isGiftItem(item));
      const realItems = cart.items.filter((item) => !this.isGiftItem(item) && !this.isCrossSellItem(item));

      if (cart.items.length > 0 && realItems.length === 0) {
        const updates = {};
        cart.items.forEach((item) => {
          updates[item.key] = 0;
        });
        const cleared = await this.postCart('/cart/update.js', {
          updates,
          sections: 'old-cart-drawer,cart-icon-bubble'
        });
        await window.refreshCart(cleared, true);
        return;
      }

      const eligible = cart.items.reduce((sum, item) => {
        if (this.isGiftItem(item)) return sum;
        return sum + (item.final_line_price || 0);
      }, 0);

      const desiredIds = steps
        .filter((step) => (step.type === 'product' || step.type === 'discount') && step.variantId && eligible >= step.threshold * rate)
        .map((step) => step.variantId);

      const updates = {};
      giftItems.forEach((item) => {
        const variantId = item.variant_id || item.id;
        if (!desiredIds.includes(variantId)) {
          updates[item.key] = 0;
        } else if (item.quantity !== 1) {
          updates[item.key] = 1;
        }
      });

      const presentIds = giftItems.map((item) => item.variant_id || item.id);
      const toAdd = desiredIds
        .filter((variantId, index) => desiredIds.indexOf(variantId) === index && !presentIds.includes(variantId))
        .map((variantId) => ({
          id: variantId,
          quantity: 1,
          properties: {
            _is_gift: 'true',
            _hover_gift: 'true'
          }
        }));

      let latest = null;
      if (Object.keys(updates).length) {
        latest = await this.postCart('/cart/update.js', {
          updates,
          sections: 'old-cart-drawer,cart-icon-bubble'
        });
      }
      if (toAdd.length) {
        latest = await this.postCart('/cart/add.js', {
          items: toAdd,
          sections: 'old-cart-drawer,cart-icon-bubble'
        });
      }
      if (latest) {
        await window.refreshCart(latest, true);
      }
      window.hoverCartProgress?.paint(eligible);
    } catch (error) {
      console.error('[GiftManager] progress sync failed', error);
    } finally {
      this.isProcessing = false;
      if (this.pendingProgressSync) {
        this.pendingProgressSync = false;
        this.syncProgressGifts();
      }
    }
  }

  async checkGiftStatus(cart = null) {
    const progress = document.querySelector('.cart-progress--new');
    if (progress && !isCartVariantHidden(progress)) {
      return this.syncProgressGifts(cart);
    }
    const legacy = document.querySelector('.cart-progress--old');
    if (legacy && isCartVariantHidden(legacy)) return;
    if (this.isProcessing) return;
    
    const config = this.getConfig();
    if (!config || !config.enabled || !config.giftVariantId) return;

    try {
      if (!cart) {
        cart = await this.fetchCart();
      }

      const giftItem = this.findGiftInCart(cart);
      const cartTotalWithoutGift = this.getCartTotalWithoutGift(cart, giftItem);
      const isEligible = cartTotalWithoutGift >= config.threshold;
      
      if(giftItem && giftItem.id != config.giftVariantId){
         await this.removeGift(giftItem);
        const da = await this.fetchCart();
        this.isProcessing = false;
        console.log(da,"customcheck");
        await this.checkGiftStatus(da);
      }

      if(giftItem && giftItem.id != config.giftVariantId){
         await this.removeGift(giftItem);
        const da = await this.fetchCart();
        this.isProcessing = false;
        console.log(da,"customcheck");
        await this.checkGiftStatus(da);
      }
      
      if (isEligible && !giftItem) {
        await this.addGift(config.giftVariantId);
      } else if (!isEligible && giftItem) {
        await this.removeGift(giftItem);
      }
    } catch (error) {
      console.error('[GiftManager] Error checking gift status:', error);
    }
  }

  findGiftInCart(cart) {
    return cart.items.find(item => 
      item.properties && String(item.properties[this.giftPropertyKey]) === 'true'
    );
  }

  getCartTotalWithoutGift(cart, giftItem) {
    if (!giftItem) return cart.total_price;
    return cart.total_price - (giftItem.final_line_price || 0);
  }

  async addGift(variantId) {
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    console.log('[GiftManager] Adding gift to cart:', variantId);
    
    try {
      const formData = {
        items: [{
          id: parseInt(variantId),
          quantity: 1,
          properties: {
            [this.giftPropertyKey]: 'true'
          }
        }],
        sections: 'old-cart-drawer,cart-icon-bubble'
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to add gift to cart');
      }

      const data = await response.json();
      await window.refreshCart(data);
      
      console.log('[GiftManager] Gift added successfully');
    } catch (error) {
      console.error('[GiftManager] Error adding gift:', error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    }
  }

  async removeGift(giftItem) {
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    console.log('[GiftManager] Removing gift from cart:', giftItem.key);
    
    try {
      const updateData = {
        updates: {
          [giftItem.key]: 0
        },
        sections: 'old-cart-drawer,cart-icon-bubble'
      };

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        throw new Error('Failed to remove gift from cart');
      }

      const data = await response.json();
      await window.refreshCart(data);
      
      console.log('[GiftManager] Gift removed successfully');
    } catch (error) {
      console.error('[GiftManager] Error removing gift:', error);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    }
  }

  async fetchCart() {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.json`);
    return response.json();
  }

  debouncedCheck(cart = null) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    
    this.debounceTimer = setTimeout(() => {
      this.checkGiftStatus(cart);
    }, 300);
  }

  isGiftItem(item) {
    return item.properties && String(item.properties[this.giftPropertyKey]) === 'true';
  }
}

// Initialize GiftManager globally
window.giftManager = new GiftManager();

window.hoverCartProgress = {
  memory: { ready: false, reached: 0, successUntil: 0, successIndex: -1, popFrom: -1, eligible: null },

  escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  },

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || window.money_format);
    }
    return (cents / 100).toFixed(2);
  },

  paint(eligibleCents) {
    const root = document.querySelector('[data-hover-progress]');
    if (!root) return;

    const steps = Array.from(root.querySelectorAll('[data-progress-step]'));
    const memory = this.memory;
    if (typeof eligibleCents === 'number') memory.eligible = eligibleCents;
    const eligible = typeof eligibleCents === 'number'
      ? eligibleCents
      : (typeof memory.eligible === 'number' ? memory.eligible : parseInt(root.dataset.eligible, 10) || 0);
    const rate = parseFloat(window.Shopify?.currency?.rate || '1') || 1;
    const forced = steps.map((step) => step.dataset.forceUnlocked === 'true');
    const thresholds = steps.map((step, index) => forced[index] ? 0 : (parseInt(step.dataset.threshold, 10) || 0) * rate);
    const reached = thresholds.filter((threshold, index) => forced[index] || (threshold > 0 && eligible >= threshold)).length;
    const decreased = memory.ready && reached < memory.reached;
    let popFrom = -1;

    if (!memory.ready) {
      memory.ready = true;
      memory.reached = reached;
    } else if (reached > memory.reached) {
      popFrom = memory.reached;
      if (reached < steps.length) {
        memory.successUntil = Date.now() + 2600;
        memory.successIndex = reached - 1;
      } else {
        memory.successUntil = 0;
      }
      memory.reached = reached;
    } else if (decreased) {
      memory.successUntil = 0;
      memory.reached = reached;
    }

    const centers = thresholds.map((_, index) => ((index + 0.5) / thresholds.length) * 100);
    let fill = 0;
    if (!thresholds.length || (eligible <= 0 && reached === 0)) {
      fill = 0;
    } else if (reached >= thresholds.length) {
      fill = 100;
    } else if (reached === 0) {
      fill = thresholds[0] > 0 ? (eligible / thresholds[0]) * centers[0] : 0;
    } else {
      const start = centers[reached - 1];
      const end = centers[reached];
      const span = thresholds[reached] - thresholds[reached - 1];
      const ratio = span > 0 ? (eligible - thresholds[reached - 1]) / span : 0;
      fill = start + ratio * (end - start);
    }
    fill = Math.max(0, Math.min(100, fill));

    root.classList.toggle('is-instant', decreased);
    root.style.setProperty('--progress', fill + '%');
    if (decreased) {
      requestAnimationFrame(() => root.classList.remove('is-instant'));
    }

    const unlockedLabel = root.dataset.unlockedLabel || 'Débloqué';
    const showingSuccess = Date.now() < memory.successUntil && memory.successIndex > -1;
    if (popFrom > -1) memory.popFrom = popFrom;
    const popStart = popFrom;
    steps.forEach((step, index) => {
      const unlocked = index < reached;
      step.classList.toggle('is-unlocked', unlocked);
      if (popStart > -1 && index >= popStart && index < reached && !step.classList.contains('is-pop')) {
        step.classList.remove('is-pop');
        void step.offsetWidth;
        step.classList.add('is-pop');
      }
      const status = step.querySelector('[data-locked-label]');
      if (status) status.textContent = unlocked ? unlockedLabel : (step.dataset.lockedText || '');
    });

    const message = root.querySelector('[data-progress-message]');
    if (showingSuccess) {
      root.dataset.state = 'success';
      if (message) message.textContent = steps[memory.successIndex]?.dataset.successText || '';
    } else if (reached >= steps.length && steps.length > 0) {
      root.dataset.state = 'final';
      if (message) message.textContent = root.dataset.finalText || '';
    } else {
      root.dataset.state = 'progress';
      const next = steps[reached];
      const remaining = next ? Math.max(0, thresholds[reached] - eligible) : 0;
      const template = next?.dataset.progressText || '';
      if (message) {
        message.innerHTML = this.escapeHtml(template).replace(
          '[remaining_amount]',
          '<strong class="hover-cart-progress__amount">' + this.escapeHtml(this.formatMoney(remaining)) + '</strong>'
        );
      }
    }

    const progressTitle = root.dataset.crossProgress;
    const doneTitle = root.dataset.crossDone;
    document.querySelectorAll('.cart-cross-sell--new [data-cross-sell-title]').forEach((title) => {
      const complete = reached >= steps.length && steps.length > 0;
      title.textContent = complete ? (doneTitle || title.textContent) : (progressTitle || title.textContent);
    });

    if (this.successTimer) {
      clearTimeout(this.successTimer);
      this.successTimer = null;
    }
    if (showingSuccess) {
      this.successTimer = setTimeout(() => {
        this.successTimer = null;
        this.paint();
      }, Math.max(0, memory.successUntil - Date.now()));
    } else {
      memory.popFrom = -1;
    }
  }
};

// Cart drawer
let $openCart, $closeCart, $cart, $overlay, $quantityInputs, $quantityButtons, $removeButtons;
let $html = document.querySelector('html');
let $body = document.querySelector('body');
document.addEventListener("DOMContentLoaded", function () {
  bindEvents();
  refreshUpsellSlider();
  window.hoverCartProgress?.paint();
  
  // Initial gift status check after page load
  setTimeout(() => {
    if (window.giftManager) {
      window.giftManager.checkGiftStatus();
    }
  }, 500);
});

function isCartVariantHidden(el) {
  if (!el) return true;
  const drawer = document.getElementById('cart-drawer');
  let node = el;
  while (node && node !== drawer && node !== document.documentElement) {
    if (node.classList.contains('hide')) return true;
    if (window.getComputedStyle(node).display === 'none') return true;
    node = node.parentElement;
  }
  return false;
}

function refreshUpsellSlider() {
    const $list = $('.cart-cross-sell--old .cart-upsell__list');
    if (!$list.length) return;
    if (isCartVariantHidden($list.closest('.cart-cross-sell--old')[0])) {
      if ($list.hasClass('slick-initialized')) $list.slick('unslick');
      return;
    }

    if ($list.hasClass('slick-initialized')) {
        $list.slick('unslick');
    }

    const size = parseInt($list.data('size'), 10) || 0;
    if (size <= 1) return;

    const visible = parseFloat(getComputedStyle($list[0]).getPropertyValue('--upsell-visible')) || 1.5;

    $list.slick({
        infinite: false,
        arrows: false,
        slidesToShow: visible,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: false
    });
}

// Custom events
document.addEventListener('cart:open', openCart);
document.addEventListener('cart:close', closeCart);
// Trigger a custom event : document.dispatchEvent(new CustomEvent('cart:open'))

document.addEventListener('cart:add', function (e) {
  let formData = e.detail.data;
  if (!formData) return;
  let triggerButton = e.detail.button; // Get the button that triggered add to cart
  let skipGiftCheck = e.detail.skipGiftCheck || false; // Allow skipping gift check
  formData.sections = "old-cart-drawer,cart-icon-bubble";
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    response.json().then(async data => {
      await window.refreshCart(data, skipGiftCheck);
      openCart();
      
      // Remove loading state from trigger button
      if (triggerButton) {
        triggerButton.classList.remove('loading');
        const spinner = triggerButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }).catch(error => {
    console.error('Error:', error);
    
    // Remove loading state on error too
    if (triggerButton) {
      triggerButton.classList.remove('loading');
      const spinner = triggerButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  });
});

function bindEvents() {
  $openCart = document.querySelector(cart_icon);
  $closeCart = document.querySelector('.cart-drawer__close');
  $cart = document.querySelector('.cart-drawer');
  $overlay = document.querySelector('.cart-drawer-overlay');
  $quantityInputs = document.querySelectorAll('.cart-drawer .quantity-selector__input');
  $quantityButtons = document.querySelectorAll('.cart-drawer .quantity-selector__button');
  $removeButtons = document.querySelectorAll('.cart-item__remove-item');
  
  if ($openCart) {
    $openCart.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  }
  
  if ($closeCart) {
    $closeCart.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  }
  
  if ($overlay) {
    $overlay.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  }

  // Cart quantity selector
  $quantityInputs.forEach(function (elem) {
    elem.addEventListener('change', async function () {
      let value = parseInt(this.value);
      let variantId = this.closest('.cart-item').getAttribute('data-variant-id');
      let lineId = this.closest('.cart-item').getAttribute('data-line-id');

      // Remove item and linked items when setting quantity to 0
      if (value == 0) {
        await removeItem(variantId, lineId);
        return;
      }
      let changeData = {
        'id': variantId,
        'quantity': value,
        'sections': 'old-cart-drawer,cart-icon-bubble'
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(changeData)
      }).then(response => {
        response.json().then(async data => {
          await window.refreshCart(data);
        });
      }).catch(error => {
        console.error('Error:', error);
      });
    });
  });

  // Quantity minus and plus click
  $quantityButtons.forEach(function (elem) {
    elem.addEventListener('click', function () {
      let currentInput = this.closest('.quantity-selector').querySelector('input');
      $cart.classList.add('is-loading');
      if (this.classList.contains('quantity-selector__minus')) {
        currentInput.stepDown();
      } else if (this.classList.contains('quantity-selector__plus')) {
        currentInput.stepUp();
      }

      if (this.getAttribute("data-item-remove-bundle")) {
         removeBundle(this.getAttribute("data-item-remove-bundle"));
      }

      // Trigger input change event
      var event = new Event('change');
      currentInput.dispatchEvent(event);
    });
  });

  // Remove buttons

  $removeButtons.forEach(function (elem) {
    elem.addEventListener('click', async function () {
      $cart.classList.add('is-loading');
      let variantId = this.closest('.cart-item').getAttribute('data-variant-id');
      let lineId = this.closest('.cart-item').getAttribute('data-line-id');

      if (this.getAttribute("data-item-remove-bundle")) {
        await removeBundle(this.getAttribute("data-item-remove-bundle"));
      } else {
        await removeItem(variantId, lineId);
      }
    });
  });

  bindCrossSellDrag();
}

function bindCrossSellDrag() {
  document.querySelectorAll('.cart-upsell__list--snap').forEach((list) => {
    if (list.dataset.dragBound === 'true') return;
    list.dataset.dragBound = 'true';

    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let moved = false;

    list.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target.closest('button, select, a, input, textarea, label')) return;
      pointerId = event.pointerId;
      moved = false;
      startX = event.clientX;
      startScroll = list.scrollLeft;
      list.classList.add('is-grabbing');
      list.setPointerCapture(event.pointerId);
    });

    list.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      const dx = event.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      list.scrollLeft = startScroll - dx;
    });

    const endDrag = (event) => {
      if (pointerId !== event.pointerId) return;
      pointerId = null;
      list.classList.remove('is-grabbing');
    };
    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);

    list.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    list.addEventListener('wheel', (event) => {
      if (list.scrollWidth <= list.clientWidth + 1) return;
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      list.scrollLeft += event.deltaY;
      event.preventDefault();
    }, { passive: false });
  });
}

async function removeBundle(bundleId) {
  const data = await getCart();
  let updateData = {
    updates: {},
    sections: "old-cart-drawer,cart-icon-bubble"
  };

  let BundleItems = data.items.filter(function (item) {
     return item.properties !== null && (item.properties['_bundleId'] === parseInt(bundleId) || item.properties['_customBundleId'] === parseInt(bundleId));
  }).map(item => item.key);


  BundleItems.forEach(function (itemKey) {
    updateData.updates[itemKey] = 0;
  });

  await updateCart(updateData)
}

async function removeItem(variantId, lineId) {
  const data = await getCart();

  let updateData = {
    updates: {
      [lineId]: 0
    },
    sections: "old-cart-drawer,cart-icon-bubble"
  };

  // Get associated items id and pass it to the data
  let linkedItems = data.items.filter(function (item) {
    return item.properties !== null && item.properties['_linkedVariant'] == variantId;
  }).map(item => item.key);
  linkedItems.forEach(function (itemKey) {
    updateData.updates[itemKey] = 0;
  });

  // Remove all items if only upsell products or gift products left
  let nonLinkedItems = data.items.filter(function (item) {
    return item.id !== parseInt(variantId) && !linkedItems.includes(item.id);
  });

  if (nonLinkedItems.length > 0) {
    let allUpsellOrGift = nonLinkedItems.every(item => 
      item.properties && (item.properties['_upsell'] === true || String(item.properties['_upsell']) === 'true' || String(item.properties['_is_gift']) === 'true')
    );

    if (allUpsellOrGift) {
      data.items.forEach(item => {
        if (updateData.updates[item.key] !== item.key) {
          updateData.updates[item.key] = 0;
        }
      });
    }
  }

  await updateCart(updateData)
}

async function getCart() {
  try {
    const response = await fetch(`${window.routes.cart_url}.json`, { cache: 'no-store' })
    return await response.json()
  } catch (error) {
    console.error('An error occurred while fetching the cart:', error)
  }
}

function payableItemCount(cart) {
  if (!cart || !Array.isArray(cart.items)) return 0;
  return cart.items.reduce((sum, item) => {
    const props = item.properties || {};
    const isGift = String(props._is_gift) === 'true' || (props._parent_variant_id != null && props._parent_variant_id !== '');
    return isGift ? sum : sum + (item.quantity || 0);
  }, 0);
}

async function updateCart(updateData) {
  const body = JSON.stringify(updateData)
  try {
    const response = await fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{body}})
    const responseData = await response.json()
    await window.refreshCart(responseData);
  } catch (error) {
    $cart.classList.remove('is-loading');
    console.error('An error occurred while modifying the cart:', error)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
  };
}

function openCartBundleModal(productId) {
  document.querySelectorAll('.custom-modal__centered.active').forEach((modal) => {
    modal.classList.remove('active');
  });
  const modal = document.querySelector('.cart-drawer-bundle-modal[data-id="' + productId + '"]');
  if (!modal) return;
  modal.classList.add('active');
  document.body.classList.add('remove-zindex');
}

document.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-cart-bundle-open]');
  if (!opener || opener.classList.contains('cart-upsell__add-btn')) return;
  event.preventDefault();
  openCartBundleModal(opener.getAttribute('data-cart-bundle-open'));
});

// Upsell add to cart
let upsellAddButtons = document.querySelectorAll('.cart-upsell__add-btn');
upsellAddButtons.forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const bundleId = button.getAttribute('data-cart-bundle-open');
    if (bundleId) {
      openCartBundleModal(bundleId);
      return;
    }
    let variantId = button.closest('.cart-upsell__actions').querySelector('[name="variant_id"]').value;
    let formData = {
      "items": [{
        "id": variantId,
        "properties": {
          "_upsell": true
        },
        "quantity": 1
      }]
    };
    document.dispatchEvent(new CustomEvent("cart:add", {
      detail: {
        data: formData
      }
    }));
  });
});

// Upsell selector
document.querySelectorAll('.cart-upsell select[name="variant_id"]').forEach(function (select) {
  select.addEventListener('change', function () {
    let variantId = select.value;
    select.closest('.cart-upsell__actions').querySelector('input[name="variant_id"]').value = variantId;

    // Handle image change
    select.closest('.cart-upsell__item').querySelectorAll('.cart-upsell__image').forEach(function (image) {
      image.style.display = "none";
    });
    select.closest('.cart-upsell__item').querySelector(`.cart-upsell__image[data-variant-id="${variantId}"]`).style.display = "block";

    // Handle button state when sold out
    if (select.classList.contains('sold-out')) {
      select.closest('.cart-upsell__actions').querySelector('.cart-upsell__add-btn').classList.add('cart-upsell__add-btn--soldout');
    } else {
      select.closest('.cart-upsell__actions').querySelector('.cart-upsell__add-btn').classList.remove('cart-upsell__add-btn--soldout');
    }
  });
});

// Re-render the cart
window.refreshCart = async function (data, skipGiftCheck = false) {
  console.log('data', data);
  let cartHtml = data.sections['old-cart-drawer'];
  let cartBarContainer = document.querySelector('#shopify-section-old-cart-drawer .cart-bar');
  let cartListContainer = document.querySelector('#shopify-section-old-cart-drawer .cart-drawer__content');
  let cartFooterContainer = document.querySelector('#shopify-section-old-cart-drawer .cart-drawer__footer');
  let customShippingBar = document.querySelector(".cart-progress--old, .cart-progress--new, .custom-ss-bar-t");
  cartListContainer.innerHTML = ""; // Empty the cart content
  cartFooterContainer.innerHTML = ""; // Empty the cart footer content

  let cartCountHtmlresponse = data.sections['cart-icon-bubble'];
let cartCountHtml = new DOMParser().parseFromString(cartCountHtmlresponse, 'text/html').querySelector("#shopify-section-cart-icon-bubble").innerHTML;
console.log(cartCountHtml,"cartCountHtml");
 document.querySelector("#cart-icon-bubble").innerHTML = cartCountHtml;
  if(cartBarContainer){
    cartBarContainer.innerHTML = ""; // Empty the cart bar content
  }
 
 
  let template = document.createElement("div");
  template.innerHTML = cartHtml;
  const progressMemory = window.hoverCartProgress?.memory;
  const keepUnlockMessage = progressMemory && Date.now() < progressMemory.successUntil;
  ['cart-progress--old', 'cart-progress--new'].forEach(function (cls) {
    const current = document.querySelector('.' + cls);
    const next = template.querySelector('.' + cls);
    if (!current || !next) return;
    if (cls === 'cart-progress--new' && keepUnlockMessage) return;
    current.innerHTML = next.innerHTML;
  });
  if (!document.querySelector('.cart-progress') && customShippingBar && template.querySelector('.custom-ss-bar-t')) {
    customShippingBar.innerHTML = template.querySelector('.custom-ss-bar-t').innerHTML;
  }
  const nextProgress = template.querySelector('[data-hover-progress]');
  const nextEligible = nextProgress ? parseInt(nextProgress.dataset.eligible, 10) : NaN;
  window.hoverCartProgress?.paint(Number.isFinite(nextEligible) ? nextEligible : undefined);
  let cartBarContents = template.querySelectorAll('#shopify-section-old-cart-drawer .cart-bar > *'); // Get the new content of the cart
  const cartSlots = document.querySelectorAll('.cart-progress, .cart-cross-sell');
  if (data.items && data.items.length === 0) {
    cartSlots.forEach(function (slot) { slot.classList.add('hide'); });
  } else {
    cartSlots.forEach(function (slot) { slot.classList.remove('hide'); });
  }
  if(cartBarContents.length > 0){
     // Add the new content in the cart
  cartBarContents.forEach(function (content) {
    cartBarContainer.append(content);
  });

  }
  

  

  let cartListContents = template.querySelectorAll('#shopify-section-old-cart-drawer .cart-drawer__content > *'); // Get the new content of the cart
  let cartFooterContents = template.querySelectorAll('#shopify-section-old-cart-drawer .cart-drawer__footer > *');

  if(cartListContents.length > 0){
    // Add the new content in the cart
    cartListContents.forEach(function (content) {
      cartListContainer.append(content);
    });
  }
  ['cart-cross-sell--old', 'cart-cross-sell--new'].forEach(function (cls) {
    if (!template.querySelector('.' + cls)) {
      document.querySelector('.' + cls)?.classList.add('hide');
    }
  });
if(cartFooterContents.length > 0){
  
  // Add the new content in the cart
  cartFooterContents.forEach(function (content) {
    cartFooterContainer.append(content);
  });

}
  // Count excludes gift lines and comes from the section just rendered.
  let cart = await getCart();
  const renderedCount = template.querySelector('.cart-drawer__count');
  const payingCount = renderedCount
    ? renderedCount.textContent.trim()
    : String(payableItemCount(cart));
  const drawerCount = document.querySelector('.cart-drawer__count');
  if (drawerCount) drawerCount.textContent = payingCount;

  let headerCount = document.querySelector(cart_count);
  if (headerCount) {
    const visibleCount = headerCount.querySelector('[aria-hidden="true"]');
    if (visibleCount) visibleCount.textContent = payingCount;
    else headerCount.textContent = payingCount;
    headerCount.style.display = payingCount === '0' || payingCount === '' ? "none" : "flex";
  }

  // Remove loading states
  $cart.classList.remove('is-loading');
  document.querySelectorAll('form[action$="/cart/add"] button[type="submit"]').forEach(function (elem) {
    elem.classList.remove('is-loading');
  });
  document.dispatchEvent(new CustomEvent("cart_drawer:updated", {
      detail: {
        cart: cart
      }
    }));
  bindEvents();
  refreshUpsellSlider();

  // Check gift status after cart update (unless skipped)
  if (!skipGiftCheck && window.giftManager) {
    window.giftManager.debouncedCheck(cart);
  }
};

// Open the cart
function openCart() {
  if ($cart) $cart.classList.add('is-active');
  if ($overlay) $overlay.classList.add('is-active');
  if ($body) $body.classList.add('no-scroll');
}

// Close the cart
function closeCart() {
  if ($cart) $cart.classList.remove('is-active');
  if ($overlay) $overlay.classList.remove('is-active');
  if ($body) $body.classList.remove('no-scroll');
}
